import { ColumnDef, ColumnOrderState, ColumnSort, SortingState } from '@tanstack/react-table';
import { COLUMN_ID_QUICKMENU, COLUMN_ID_SELECT, ColumnFilter, ColumnFiltersState } from '@components/primitives/dataGrid/DataGrid';

// sometimes the saved sorting/filtering may contain column ids that don't exist (anymore).
// In that case an error will occur. To prevent that, we filter non-existent colom ids from this state.

export const purifyColumnFilters = <TData>(columnFiltersState: ColumnFiltersState, columns: Array<ColumnDef<TData>>): ColumnFiltersState => {
    return columnFiltersState
        ?.filter((columnFilter: ColumnFilter) => {
            return columns.findIndex((column) => column.id === columnFilter.id) !== -1;
        })
        .map((columnFilter: ColumnFilter) => {
            const column = columns.find((col) => col.id === columnFilter.id);

            // Migrate saved numeric filter to new format
            if (column?.filterFn === 'numeric' && typeof columnFilter.value === 'string') {
                return {
                    ...columnFilter,
                    value: [columnFilter.value, columnFilter.value],
                };
            }

            // Migrate saved select filter to new format
            if (column?.filterFn === 'select' && typeof columnFilter.value === 'string') {
                return {
                    ...columnFilter,
                    value: [columnFilter.value],
                };
            }

            return columnFilter;
        });
};

export const purifySorting = <TData>(sortingState: SortingState, columns: Array<ColumnDef<TData>>): SortingState => {
    return sortingState?.filter((columnSort: ColumnSort) => {
        return columns.findIndex((column) => column.id === columnSort.id) !== -1;
    });
};

export const purifyColumnOrder = <TData>(columnOrder: ColumnOrderState, columns: Array<ColumnDef<TData>>): ColumnOrderState => {
    const allColumnIds = columns.map((col) => col.id).filter((columnId) => typeof columnId === 'string');
    const missingColumnsInOrder = allColumnIds.filter((columnId) => columnId && !columnOrder.includes(columnId));
    const userColumns = columnOrder.filter((columnId) => {
        return columnId && columnId !== COLUMN_ID_SELECT && columnId !== COLUMN_ID_QUICKMENU && allColumnIds.includes(columnId);
    });

    return [COLUMN_ID_SELECT, ...userColumns, ...missingColumnsInOrder, COLUMN_ID_QUICKMENU];
};
